import { P2GGrid, P2GText } from '@parcel2go/core-ui';

type ProductItemDateProps = {
  date: string;
  icon: React.ReactNode;
  title: string;
};

export function ProductItemDate({ date, icon, title }: ProductItemDateProps) {
  return (
    <P2GGrid container wrap="nowrap" spacing={2}>
      <P2GGrid item>{icon}</P2GGrid>
      <P2GGrid item>
        <P2GGrid container direction="column">
          <P2GGrid item>
            <P2GText color="textSecondary" variant="body1" fontWeight="bold">
              {title}
            </P2GText>
          </P2GGrid>
          <P2GGrid item>
            <P2GText variant="body2">{date}</P2GText>
          </P2GGrid>
        </P2GGrid>
      </P2GGrid>
    </P2GGrid>
  );
}
